import React from 'react';
import Switch from '@material-ui/core/Switch';

import { withStyles } from '@material-ui/styles';

const MaterialSwitch = withStyles((theme) => ({
  switchBase: {
    color: theme.custom.switch.color,
    '&$checked': {
      color: theme.custom.switch.checkedColor,
    },
    '&$checked + $track': {
      backgroundColor: theme.custom.switch.checkedColor,
    },
    '&$checked:hover': {
      backgroundColor: theme.custom.switch.checkedHoverBackground,
    },
  },
  checked: {},
  track: {
    backgroundColor: theme.custom.switch.trackColor,
  },
}))(Switch);

export default MaterialSwitch;

